import React, {useRef, useState} from 'react'
import firebase from './../../../../config/fbConfig'

const db = firebase.firestore(); 

function RemoveProduct(props) {
    const productName = useRef()
    const [searches, setSearches] = useState([]) // Used to store all the matching products object according to the search
    const forceUpdate = React.useState()[1].bind(null, {})

    let ExecuteSearch = (e, name) => {
        e.preventDefault();
        if (name.length < 3) {
            if (window.location.href.includes('/en')) { 
                alert("You must enter at least 3 characters to search.");
            } else {
                alert("עליך להקליד לפחות 3 תווים כדי לבצע חיפוש.");
            }    
            return;
        }
        

        let newArr = []; 
        // Searching the items according to the search
        props.menu.map((value, categoryIndex) => {
            value.products.map((product, productIndex) => {
                // Using indexOf and not includes because Includes isn't supposed in internet explorer :@
                if (product.productName.toLowerCase().indexOf(name.toLowerCase()) !== -1) {
                    product.categoryName = value.title;
                    product.categoryIndex = categoryIndex; // Storing their index to get an easy remove when the user trying
                    product.productIndex = productIndex;  //    ^
                    newArr.push(product);
                 }
                 
            })
        })
        setSearches(newArr);
        if (newArr.length===0) {
            document.getElementById('removeProduct').reset();
        }
    }

    let removeProduct = (categoryIndex, productIndex, searchIndex, productName) => {
        if (window.location.href.includes('/en')) { 
            if (!window.confirm(`Are you sure you want to 𝗥𝗘𝗠𝗢𝗩𝗘 \n${productName} from ${props.menu[categoryIndex].title} category?`)) return;
        } else {
            if (!window.confirm(`האם אתה בטוח שברצונך למחוק את \n${productName} מקטגוריית ${props.menu[categoryIndex].title}?`)) return;
        }
        

        let chosenCategory = props.menu[categoryIndex].title.replace(/\s/g, ''); // To remove the spaces from chosen category to actually it valid name for folder in Firebase Storage
        let url = props.menu[categoryIndex].products[productIndex].picURL;

        // If it is a local file, so removing it from the storage
        if (url.indexOf('firebasestorage') !== -1) {
            // Getting the file's name with it's ending tag (.jpg/etc..)
            let name = url.substr(url.indexOf('%2F') + 3, (url.indexOf('?')) - (url.indexOf('%2F') + 3));
            name = name.replace('%20',' ');
            firebase.storage().ref(chosenCategory + '/' + name).delete();
        }
        
        props.menu[categoryIndex].products.splice(productIndex, 1); // Updating the menu


        let categoryLang = 'categories' + props.chosenLang;
        db.collection('menu').doc('categories').update({
            [categoryLang]: props.menu
        });

        if (window.location.href.includes('/en')) { 
            alert("Successfully removed!");
        } else {
            alert("נמחק בהצלחה!");
        }
        
        searches.splice(searchIndex, 1); // Updating the Search State for UI
        setSearches(searches);
        forceUpdate();
    }
    
if (window.location.href.includes('/en')) { 
    return (
        <div>
            <form id="removeProduct">
                <div className="middleWrapper">
                    <label>Enter Item's name<span></span> </label>
                    <input type="text" ref={productName}/>
                    <button id="mainButton" onClick={(e) => ExecuteSearch(window.event, productName.current.value)}>SEARCH</button>
                </div>
            </form>

            <div id="searchesProducts">
                {searches.length===0  ? <div style={{paddingTop: '20px'}}> No results found </div>
                :
                <ol>
                    {searches.map((value, index) => 
                        <li key={index} onClick={() => removeProduct(value.categoryIndex, value.productIndex, index, value.productName)}>{value.productName} €{value.price} ({value.categoryName}) </li>
                    )}
                </ol>
                }
            </div>
        </div> 
    )
}
    return (
        <div>
            <form id="removeProduct">
                <div className="middleWrapper">
                    <label>שם המוצר<span></span> </label>
                    <input type="text" ref={productName}/>
                    <button id="mainButton" onClick={(e) => ExecuteSearch(window.event, productName.current.value)}>חיפוש</button>
                </div>
            </form>

            <div id="searchesProducts">
                {searches.length===0  ? <div style={{paddingTop: '20px'}}> לא נמצאו תוצאות </div>
                :
                <ol>
                    {searches.map((value, index) => 
                        <li key={index} onClick={() => removeProduct(value.categoryIndex, value.productIndex, index, value.productName)}>{value.productName} €{value.price} ({value.categoryName}) </li>
                    )}
                </ol>
                }
            </div>
        </div>
    )
}

export default RemoveProduct
